export class InferencePolicyModel {
    manifest;
    data;
    constructor(manifest, data) {
        this.manifest = manifest;
        this.data = data;
    }
    logits(obs) {
        let x = obs;
        for (let layer = 0; layer < 4; layer++) {
            x = this.dense(x, this.manifest.layers[layer], true);
        }
        return this.dense(x, this.manifest.layers[4], false);
    }
    policy(obs, legalMask) {
        const logits = this.logits(obs);
        let max = -Infinity;
        for (let action = 0; action < 38; action++) {
            if (legalMask[action] && logits[action] > max)
                max = logits[action];
        }
        const probabilities = new Float32Array(38);
        let sum = 0;
        for (let action = 0; action < 38; action++) {
            if (legalMask[action]) {
                probabilities[action] = Math.exp(logits[action] - max);
                sum += probabilities[action];
            }
        }
        for (let action = 0; action < 38; action++)
            probabilities[action] /= sum;
        return probabilities;
    }
    dense(x, layer, relu) {
        const [inputSize, outputSize] = layer.w.shape;
        const output = new Float32Array(outputSize);
        for (let column = 0; column < outputSize; column++)
            output[column] = this.data[layer.b.offset + column];
        for (let row = 0; row < inputSize; row++) {
            const value = x[row];
            if (value === 0)
                continue;
            const offset = layer.w.offset + row * outputSize;
            for (let column = 0; column < outputSize; column++)
                output[column] += value * this.data[offset + column];
        }
        if (relu) {
            for (let column = 0; column < outputSize; column++)
                if (output[column] < 0)
                    output[column] = 0;
        }
        return output;
    }
}
//# sourceMappingURL=model-inference.js.map